import axios from 'axios';

// const API_URL = 'http://127.0.0.1:8000/api';
const API_URL = 'http://api.dllamas.net/api';

export const getStudies = async () => {
    const response = await axios.get(`${API_URL}/studies`);
    return response.data;
};

export const  getExperiences = async () => {
    const response = await axios.get(`${API_URL}/experiences`);
    return response.data;
};
